import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import type { Request } from '../../types';
import { dedupeByOppId } from '../../utils/opportunities';
import { matchesSub } from '../../utils/filter';
interface Props {
  region: string;
  sub: string[];
  status: string;
  requests: Request[];
}
const QUARTERS = ['FY26 Q1', 'FY26 Q2', 'FY26 Q3'];
const FY_Q_LABEL: Record<string, Record<string, string>> = {
  '2026': {
    Q1: 'FY26 Q1',
    Q2: 'FY26 Q2',
    Q3: 'FY26 Q3'
  }
};
function buildTrendData(region: string, sub: string[], status: string, requests: Request[]) {
  const counts: Record<string, number> = {};
  const gnarrs: Record<string, number> = {};
  QUARTERS.forEach(q => {
    counts[q] = 0;
    gnarrs[q] = 0;
  });
  const matching = requests.filter(r => (region === 'Global' || r.opp_region === region) && matchesSub(sub, r.req_sub_region) && (!status || status === 'All' || r.req_status === status));
  // dedupeByOppId(matching).forEach(r => {
  matching.forEach(r => {
    const fy = r.req_created_fy || '';
    const q = r.req_created_q || '';
    const label = FY_Q_LABEL[fy]?.[q];
    if (label) {
      counts[label]++;
      gnarrs[label] += r.opp_gnarr;
    }
  });
  return QUARTERS.map(q => ({
    quarter: q,
    requests: counts[q],
    gnarr: Math.round(gnarrs[q] / 1e4) / 100 // → $M with 2dp
  }));
}
export function TrendChart({
  region,
  sub,
  status,
  requests
}: Props) {
  const data = buildTrendData(region, sub, status, requests);
  return <div className="mx-[18px] mb-3 bg-white border border-[#e8eaf0] rounded-[10px] p-[14px_16px] shadow-[0_1px_3px_rgba(0,0,0,0.04)]" data-id="element-113" data-mp="21fzmsfii5nzb">
      <div className="flex gap-[14px] mb-[10px] text-[10px] text-[#667085]" data-id="element-114" data-mp="2aetg9x0jdy8n">
        <span className="flex items-center gap-1" data-id="element-115" data-mp="2acqfqj1rcmpo">
          <span className="w-[10px] h-[10px] rounded-[3px] inline-block" style={{
          background: '#b8cce8'
        }} data-id="element-116" data-mp="1moh1q3asd393" />
          Requests
        </span>
        <span className="flex items-center gap-1" data-id="element-117" data-mp="1ho31h7ffexlm">
          <span className="w-[10px] h-[10px] rounded-[3px] inline-block" style={{
          background: '#d4a017'
        }} data-id="element-118" data-mp="3ht6tyh1teavc" />
          GNARR ($M)
        </span>
      </div>
      <ResponsiveContainer width="100%" height={190} data-id="element-119" data-mp="3mp5eftk0v8qh">
        <ComposedChart data={data} margin={{
        top: 4,
        right: 8,
        bottom: 0,
        left: 0
      }} data-id="element-120" data-mp="3rj9nciculqu7">
          <CartesianGrid stroke="rgba(0,0,0,0.05)" vertical={false} data-id="element-121" data-mp="c6wxt4u3ol1" />
          <XAxis dataKey="quarter" tick={{
          fontSize: 9,
          fill: '#8892a0'
        }} axisLine={false} tickLine={false} data-id="element-122" data-mp="2ytj825zhciwi" />
          <YAxis yAxisId="left" tick={{
          fontSize: 9,
          fill: '#8892a0'
        }} axisLine={false} tickLine={false} data-id="element-123" data-mp="33se1s2yzjrve" />
          <YAxis yAxisId="right" orientation="right" tick={{
          fontSize: 9,
          fill: '#8892a0'
        }} axisLine={false} tickLine={false} data-id="element-124" data-mp="38r7dbpupp8sx" />
          <Tooltip contentStyle={{
          fontSize: 11,
          border: '1px solid #e8eaf0',
          borderRadius: 6
        }} formatter={(v: number, name: string) => [name === 'gnarr' ? '$' + v + 'M' : v, name === 'gnarr' ? 'GNARR ($M)' : 'Requests']} data-id="element-125" data-mp="3cu3owwlu44nd" />
          <Legend wrapperStyle={{
          display: 'none'
        }} data-id="element-126" data-mp="2ckm6c10rsvvv" />
          <Bar yAxisId="left" dataKey="requests" fill="#b8cce8" radius={[3, 3, 0, 0]} name="requests" data-id="element-127" data-mp="28jskreasvt65" />
          <Line yAxisId="right" type="monotone" dataKey="gnarr" stroke="#d4a017" strokeWidth={2.5} dot={{
          fill: '#d4a017',
          r: 4
        }} activeDot={{
          r: 5
        }} name="gnarr" data-id="element-128" data-mp="23sagohdhdcgy" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>;
}